module.exports = __webpack_public_path__ + "static/media/rus.7f0f653e.svg";